import React, { createContext, useContext, useState, useEffect } from "react";
import moment from "moment-timezone";
// import { useMe } from "@/data/user";
interface TimezoneContextType {
  selectedTimezone: string;
  setSelectedTimezone: (timezone: string) => void;
  convertToTimezone: (date: string, time: string) => moment.Moment;
  confirmTimezoneUpdate: boolean;
  setConfirmTimezoneUpdate: (confirmTimezoneUpdate: boolean) => void;
}

const TimezoneContext = createContext<TimezoneContextType | undefined>(
  undefined,
);

export const TimezoneProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  // const { me } = useMe() || { me: null };
  const [selectedTimezone, setSelectedTimezone] = useState("Europe/Rome");
  const [confirmTimezoneUpdate, setConfirmTimezoneUpdate] = useState(false);

  // Set the local timezone for the user
  useEffect(() => {
    const localTime = moment.tz.guess(true);
    setSelectedTimezone(localTime);
  }, [selectedTimezone]);

  // TIMEZONE: TURNED OFF FOR NOW
  // useEffect(() => {
  //   if (me?.item?.user?.timezone) {
  //     setSelectedTimezone(me.item.user.timezone);
  //   }
  // }, [me]);

  const convertToTimezone = (date: string, time: string) => {
    return moment
      .tz(`${date} ${time}`, "YYYY-MM-DD HH:mm", "Europe/Rome")
      .tz(selectedTimezone);
  };

  return (
    <TimezoneContext.Provider
      value={{
        selectedTimezone,
        setSelectedTimezone,
        convertToTimezone,
        confirmTimezoneUpdate,
        setConfirmTimezoneUpdate,
      }}
    >
      {children}
    </TimezoneContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useTimezone = () => {
  const context = useContext(TimezoneContext);
  if (context === undefined) {
    throw new Error("useTimezone must be used within a TimezoneProvider");
  }
  return context;
};
